export class PlanarVideoController {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '4.0.567';
        this.power = false;
        this.presetSelection = '1';
        this.presets = [];
        this.asyncHandlers = [
            {
                name: 'firmwareQuery',
                regExp: /SYSTEM\.VERSION\?/i,
                callback: (match) => {
                    this.socket.send(`SYSTEM.VERSION:"${this.firmwareVersion}"`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /SYSTEM\.POWER\?/i,
                callback: (match) => {
                    this.socket.send(`SYSTEM.POWER:${this.power ? 'ON' : 'OFF'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /SYSTEM\.POWER=(\d)/i,
                callback: (match) => {
                    this.power = match[1] === '1';
                    this.socket.send(`SYSTEM.POWER:${this.power ? 'ON' : 'OFF'}`);
                },
            },
            {
                name: 'presetCount',
                regExp: /PRESET\.COUNT\?/i,
                callback: (match) => {
                    this.socket.send(`PRESET.COUNT:${this.presets.length}`);
                },
            },
            {
                name: 'presetList',
                regExp: /PRESET\.LIST\(?(\d*)\s?(\d*)\)?\?/i,
                callback: (match) => {
                    var _a, _b;
                    // Up to 64 presets can be returned
                    const start = (_a = parseInt(match[1], 10)) !== null && _a !== void 0 ? _a : 1;
                    const end = (_b = parseInt(match[2], 10)) !== null && _b !== void 0 ? _b : 64;
                    const presetIndices = this.presets.map(pre => pre.index);
                    const filteredPresets = presetIndices.filter(function (num) {
                        const presetNum = parseInt(num, 10);
                        if (presetNum >= start && presetNum <= end) {
                            return true;
                        }
                        return false;
                    });
                    const presetList = filteredPresets.join(' ');
                    this.socket.send(`PRESET.LIST(${start} ${end}):${presetList}`);
                },
            },
            {
                name: 'presetName',
                regExp: /PRESET\.NAME\((\d+)\)\?/i,
                callback: (match) => {
                    var _a;
                    const presetInfo = this.presets.find(pre => pre.index === match[1]);
                    this.socket.send(`PRESET.NAME(${match[1]}):"${(_a = presetInfo === null || presetInfo === void 0 ? void 0 : presetInfo.name) !== null && _a !== void 0 ? _a : ''}"`);
                },
            },
            {
                name: 'presetQuery',
                regExp: /PRESET\.ACTIVE\?/i,
                callback: (match) => {
                    this.socket.send(`PRESET.ACTIVE:${this.presetSelection}`);
                },
            },
            {
                name: 'presetRecall',
                regExp: /PRESET\.RECALL\(?(\d+)\)?/i,
                callback: (match) => {
                    this.presetSelection = match[1];
                    this.socket.send(`PRESET.RECALL(${this.presetSelection}):@ACK`);
                },
            },
            {
                name: 'invalid',
                regExp: /(.+)=.+/i,
                callback: (match) => {
                    this.socket.send(`${match[1]}!ERR 4}`);
                },
            },
        ];
        for (let i = 1; i <= 50; i++) {
            this.presets.push({
                index: `${i}`,
                name: `Preset ${i}`,
            });
        }
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code.slice(1);
            if (this.presetSelection === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        // video input codes are a-1, a-2, ...
        this.presetSelection = lowestCode ? lowestCode : '1';
    }
}
PlanarVideoController.emulatorType = 'socketEmulator';
PlanarVideoController.key = '-NI2x9KEXIfEWOuD_Nnf';
